import React, { useEffect, FC } from "react";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";

import { Form, Input, Button, message, Row, Col } from "antd";
import { LockOutlined, UserOutlined } from "@ant-design/icons";

import "../login/login.less";

import { useGetRandomCode } from "@/hook/randomCode";
import axios from "@/axios/axios";

import Base64 from "base-64";
import * as actions from "@/store/actions";
const { Search } = Input;
const ForgotForm: FC<any> = ({ history, setUserInfo }) => {
  const [form] = Form.useForm();
  const [randomImgUrl, getRandomImgFn] = useGetRandomCode<string>("");
  /**修改密码 */
  const onFinish = ({ mobile, smsCode, password }: any): void => {
    confirm({
      mobile: Base64.encode(mobile),
      smsCode: Base64.encode(smsCode),
      password: Base64.encode(password),
    });
  };

  const confirm = async (params: any) => {
    getRandomImgFn();
    const { code, msg }: any = await axios.post(
      "/user/api/ce/user/password/modify",
      params
    );
    if (code == 0) {
      history.push("/index/home");
    } else {
      message.error(msg);
    }
  };

  const sendSmsCode = async (params: any) => {
    const { code, msg }: any = await axios.post(
      "/user/api/ce/send/unify/sms/code",
      params
    );
    if (code === 0) {
      message.info("已发送验证码，请注意查收");
    } else {
      message.error(msg);
      getRandomImgFn();
    }
  };

  const smsCode = () => {
    const { mobile, verifyCode } = form.getFieldsValue();
    const smsTitle = "医视界";
    console.log(mobile, verifyCode, "-----------------------------");
    sendSmsCode({
      mobile: Base64.encode(mobile),
      smsTitle,
      verifyCode: Base64.encode(verifyCode),
    });
  };

  const FormView = (
    <Form
      form={form}
      className="login-form"
      name="login-form"
      onFinish={onFinish}
    >
      <Form.Item>
        <h2 style={{ textAlign: "center" }}>修改密码</h2>
      </Form.Item>
      <Form.Item
        name="mobile"
        rules={[{ required: true, message: "请输入手机号" }]}
      >
        <Input
          placeholder="请输入手机号"
          prefix={<UserOutlined />}
          size="large"
        />
      </Form.Item>
      <Form.Item
        name="verifyCode"
        rules={[{ required: true, message: "请输入图形验证码" }]}
      >
        <Input
          placeholder="请输入图形验证码"
          suffix={
            <img
              src={randomImgUrl}
              alt="code"
              onClick={() => {
                getRandomImgFn();
              }}
              style={{ width: "100px", height: "100%" }}
            />
          }
        />
      </Form.Item>
      <Form.Item
        name="smsCode"
        rules={[{ required: true, message: "请输入验证码!" }]}
      >
        <Search
          placeholder="请输入验证码"
          allowClear
          enterButton="获取验证码"
          size="large"
          onSearch={smsCode}
        />
      </Form.Item>
      <Form.Item
        name="password"
        rules={[{ required: true, message: "请输入密码" }]}
      >
        <Input.Password
          placeholder="请输入密码"
          prefix={<LockOutlined />}
          size="large"
          autoComplete="new-password"
        />
      </Form.Item>
      <Form.Item
        name="confirmPassword"
        dependencies={["password"]}
        hasFeedback
        rules={[
          {
            required: true,
            message: "Please confirm your password!",
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("password") === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error("两次密码输入不一致!"));
            },
          }),
        ]}
      >
        <Input.Password
          placeholder="请确认密码"
          prefix={<LockOutlined />}
          size="large"
          autoComplete="new-password"
        />
      </Form.Item>

      <Form.Item>
        <div style={{ textAlign: "center" }}>
          <Button style={{ marginRight: "20px" }}>
            <Link to="/index/home">返回</Link>
          </Button>
          <Button htmlType="submit" type="primary">
            确认
          </Button>
        </div>
      </Form.Item>
      <Form.Item>
        <div style={{ textAlign: "center" }}>
          <p>客服电话: 400-001-8080</p>
        </div>
      </Form.Item>
    </Form>
  );
  return (
    <div className="login-layout" id="login-layout">
      <div className="login-box">
        <div className="logo-name">医视界 | 远程继续医学教育平台</div>
        <div className={"login-form-box"}>{FormView}</div>
      </div>
    </div>
  );
};

export default connect((state) => state, actions)(ForgotForm);
